export enum Permission {
  Onboarding = 'onboarding',
  OnboardingRetailerProfileView = 'onboarding_retailer_profile.view',
  OnboardingRetailerProfileModify = 'onboarding_retailer_profile.modify',
  OnboardingAdminStorefrontSetupView = 'onboarding_admin_storefront_setup.view',
  OnboardingAdminStorefrontSetupModify = 'onboarding_admin_storefront_setup.modify',
  PartnerStorefrontSetupView = 'partner_storefront_setup.view',
  PartnerStorefrontSetupModify = 'partner_storefront_setup.modify',
  MobileManagementView = 'mobile_management.view',
  WhitelabelSiteCustomizableStringsView = 'whitelabel_site_customizable_strings.view',
  WhitelabelSiteCustomizableStringsModify = 'whitelabel_site_customizable_strings.modify',
}
